import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  NotificationMessage,
  NotificationsQueue,
} from '@/components/Notifications';
import { Endpoint, QueryKey } from '@/constants';
import { postData } from '@/utils/postData';

export const useApplyBalance = (applyPoints: boolean) => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: postData(
      applyPoints ? Endpoint.ApplyLoyaltyPoints : Endpoint.ClearLoyaltyPoints,
    ),
    onSuccess: data => {
      NotificationsQueue.add(
        {
          notification: (
            <NotificationMessage $isError={!data.isSuccess}>
              {data.messages[0]}
            </NotificationMessage>
          ),
        },
        { timeout: 5000 },
      );

      if (data.isSuccess) {
        queryClient.invalidateQueries({ queryKey: [QueryKey.GetCart] });
      }
    },
  });

  return mutate;
};
